export const ROLES = {
  STUDENT: "student",
  TEACHER: "teacher",
  TENANT_ADMIN: "tenant-admin",
  SUPER_ADMIN: "superadmin",
  PARENT: "parent",
};
